import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, Event } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'N° Día', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function VisitDay(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [visitDays, setVisitDays] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function loadVisitDays() {
    setDataLoading(true);
    let response = await wsGetAll('base/visit-day');
    setDataLoading(false);
    if (response.success) setVisitDays(response.data);
  }

  useEffect(() => {
    loadVisitDays();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadVisitDays} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_VISIT_DAYS_STORE}
              component={
                <CardIcon color="primary">
                  <Event style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado días de visita {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Días-de-visita"
              defaultWidth={1000}
              indexRow={[0, 3]}
              widthRow={[150, 5]}
              columns={columns}
              data={visitDays.map((visitDay, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_VISIT_DAYS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(visitDay)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_VISIT_DAYS_DELETED}>
                        <ButtonDelete
                          entity="base/visit-day"
                          id={visitDay.id}
                          reload={loadVisitDays}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  code: visitDay.code,
                  description: visitDay.description,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
